import React from 'react';
import MainTitle from '../../components/MainTitle/index';
import Header from '../../components/Header/index';
import { HelpIcon } from '../../components/Icon/index';

const NotFoundPage = () => (
  <>
    <Header>
      <MainTitle>
        <HelpIcon />
        {' '}
Not found
      </MainTitle>
    </Header>
  </>
);

export default NotFoundPage;
